import { render, staticRenderFns } from "./LoginGoogle.vue?vue&type=template&id=f2f05186&scoped=true&"
import script from "./LoginGoogle.vue?vue&type=script&lang=js&"
export * from "./LoginGoogle.vue?vue&type=script&lang=js&"
import style0 from "./LoginGoogle.vue?vue&type=style&index=0&id=f2f05186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f05186",
  null
  
)

export default component.exports